{
  "analysis": {
    "analysis_help_title": "Comment utiliser les outils",
    "analysis_help_description": "Utilisez les outils de dessin pour tracer une ligne ou une zone sur la carte. Une fois l'objet sélectionné, développez les sections ci-dessous pour afficher les différents types d'analyse."
  },
  "sidebarToolbar": {
    "delete_layer": "Supprimer la couche",
    "remove_layer": "Supprimer la couche"
  },
  "sidebarLayers": {
    "emptyLayer": "{{ layerName }} n'a pas encore d'objets",
    "emptyGroup": "{{ groupName }} ne comporte ni couches ni groupes"
  },
  "attributes": {
    "namingOrder": "Ordre de dénomination",
    "customerIdentifier": "Nom de l'identifiant du client",
    "list_items": {
      "add_another_placeholder": "Ajouter une autre option de liste",
      "add_first_placeholder": "Ajouter une option de liste"
    },
    "dataDriven": {
      "canDo": "Style piloté par les attributs",
      "noDatafields": "Ajoutez des attributs pour utiliser un style piloté par les attributs",
      "label": "Définir à l'aide d'attributs",
      "tour": {
        "stage_one": {
          "title": "Style piloté par attributs",
          "content": "Vous devez ajouter un attribut de liste avant de pouvoir styliser votre couche en fonction de valeurs d'attribut"
        }
      }
    },
    "predefined_subtitle": "Choisissez parmi un ensemble d'attributs prêts à l'emploi",
    "custom_subtitle": "Créez votre propre attribut, tel qu'une liste personnalisée ou une zone de saisie de texte",
    "attribute_type": "Type d'attribut",
    "create_new_attribute": "Créez un nouvel attribut en choisissant un type dans la liste ci-dessous et modifiez-le selon vos besoins",
    "edit_attribute": "Modifiez cet attribut en choisissant un type dans la liste ci-dessous et modifiez-le selon vos besoins",
    "edit_attribute_no_type": "Modifiez cet attribut en utilisant les champs ci-dessous et modifiez-le selon vos besoins",
    "create_attribute_title": "Créer un attribut",
    "edit_attribute_title": "Modifier l'attribut",
    "add_attribute_subtitle": "Ajoutez un nouvel attribut en choisissant un attribut prédéfini ou en en créant un nouvel attribut à partir de zéro",
    "predefined_info_title": "Attributs prédéfinis",
    "predefined_info_text": "Les administrateurs de projet peuvent les gérer dans les paramètres du projet",
    "predefined_info_link": "Cliquez ici pour accéder aux « Paramètres du projet »",
    "create_predefined_title": "Création d'un attribut prédéfini"
  },
  "styles": {
    "fill": "Remplir"
  },
  "layer_tour": {
    "tip_1_welcome": {
      "title": "Personnalisez votre couche",
      "content": "Vous pouvez modifier l'apparence de votre couche et les informations (attributs) que vous souhaitez stocker lorsque vous ajoutez des objets au plan."
    },
    "tip_2_name": {
      "title": "Nom de la couche",
      "content": "Changez le nom de votre couche pour mieux décrire ce que vous ajoutez au plan"
    },
    "tip_3_attributes": {
      "title": "Attributs",
      "content": "Ajoutez des attributs (facultatif) pour stocker des informations sur les objets du plan. Par exemple, vous pouvez saisir les types/catégories, les coûts, les quantités, les dates ou tout autre élément dont vous avez besoin."
    },
    "tip_4_styles": {
      "title": "Styles",
      "content": "Modifiez l'apparence des objets de cette couche sur le plan, par exemple les couleurs et les tailles."
    },
    "tip_5_attribute_styles": {
      "title": "Style basé sur les attributs",
      "content": "Utilisez des attributs pour déterminer l'apparence des objets. Par exemple, différents « types/catégories » peuvent avoir des couleurs différentes."
    },
    "tip_6_save": {
      "title": "Enregistrer",
      "content": "Lorsque vous avez terminé, appuyez sur Enregistrer pour ajouter la couche au plan. Vous pouvez toujours modifier ces paramètres ultérieurement, par exemple en ajoutant d'autres attributs ou en ajustant le style."
    }
  },
  "formula_summary": {
    "remove_formula": "Supprimer la formule"
  },
  "layer_information": {
    "title": "Informations sur la couche",
    "owner_map_location": "Emplacement du plan du propriétaire",
    "open_in_folder": "Ouvrir dans un dossier",
    "created_by": "Créé par",
    "created_on": "Créé le",
    "last_modified": "Dernière modification",
    "permissions": "Autorisations",
    "view_collaborators": "Afficher et modifier les collaborateurs",
    "visualiser_overflow": "... {{ nodeCount }} plus de dossiers",
    "edit_style": "Paramètres des couches"
  },
  "edit_layer": {
    "add_to_map": "Ajouter au plan",
    "customise": "Personnaliser le modèle",
    "text_position": "Position du texte",
    "text_offset": "Décalage de texte"
  },
  "style_errors": {
    "invalid_incrementor_value": "Valeur non valide. Entrez une valeur comprise entre {{ minValue }} et {{ maxValue }}"
  },
  "style": {
    "error": "Une erreur s'est produite, les modifications de couche n'ont pas été enregistrées"
  },
  "toolbarButtonTooltips": {
    "confirm_action": "Dessin complet"
  }
}